import { lightPalette } from "../palette";

export const MuiButton = {
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: "none",
        "&.Mui-disabled": {
          color: lightPalette.primary.main,
          border: "1px solid",
          borderColor: lightPalette.primary.main,
          opacity: ".25",
        },
      },
      outlined: {
        border: "1px solid",
        borderColor: lightPalette.primary.main,
        color: lightPalette.primary.main,
        "&.Mui-disabled": {
          color: lightPalette.primary.main,
          border: "1px solid",
          borderColor: lightPalette.primary.main,
          opacity: ".25",
        },
      },
      contained: {
        "&:disabled": {
          backgroundColor: lightPalette.primary.main,
          color: lightPalette.text.primary,
          opacity: "0.25",
        },
      },
    },
  },
};
